import { Container, Header, Button, Box, Alert, SpaceBetween } from '@amzn/awsui-components-core';
import React from 'react';

import { useAuth } from '../../contexts/AuthContext';

/**
 * Component displayed when authentication encounters an error
 * Provides error details and recovery options
 */
const AuthError: React.FC = () => {
  const { error, signIn } = useAuth();

  const handleRetry = async (): Promise<void> => {
    try {
      await signIn();
    } catch (err) {
      console.error('Retry authentication failed:', err);
    }
  };

  const handleRefresh = (): void => {
    window.location.reload();
  };

  return (
    <Container data-testid="auth-error" header={<Header variant="h1">Authentication Error</Header>}>
      <SpaceBetween direction="vertical" size="l">
        <Alert statusIconAriaLabel="Error" type="error" header="Unable to authenticate">
          {error ?? 'An unexpected error occurred during authentication.'}
        </Alert>

        <Box variant="p">This could be due to:</Box>

        <ul>
          <li>Network connectivity issues</li>
          <li>Amazon SSO service temporarily unavailable</li>
          <li>Your session may have expired</li>
          <li>Browser cookies or local storage issues</li>
        </ul>

        <SpaceBetween direction="horizontal" size="s">
          <Button variant="primary" onClick={() => void handleRetry()}>
            Try Again
          </Button>

          <Button onClick={handleRefresh}>Refresh Page</Button>
        </SpaceBetween>

        <Box variant="small" color="text-body-secondary">
          If the problem persists, please contact support at verity-support@amazon.com
        </Box>
      </SpaceBetween>
    </Container>
  );
};

export default AuthError;
